"use client";
import InputNumber from "antd/es/input-number";
import Input from "antd/es/input/Input";
import { CSSProperties } from "react";

type CustomInputProps = {
  style?: CSSProperties | undefined;
  value?: string;
  defaultValue?: string;
  onChange: (value: string) => void;
};
export function CustomInput({
  style,
  value,
  defaultValue,
  onChange,
}: CustomInputProps) {
  return (
    <Input
      style={{ ...style }}
      value={value}
      defaultValue={defaultValue}
      onChange={(value) => {
        onChange(value.target.value);
      }}
      allowClear
    ></Input>
  );
}
type CustomNumberInputProps = {
  style?: CSSProperties | undefined;
  value?: number;
  defaultValue?: number;
  maxValue?: number;
  onChange: (value: number) => void;
  min?: number
  max?: number
};

export function CustomNumberInput({
  style,
  value,
  maxValue,
  defaultValue,
  onChange,
  min,
  max
}: CustomNumberInputProps) {
  return (
    <InputNumber<number>
      minLength={min}
      maxLength={max}
      size="large"
      value={value}
      style={{ ...style }}
      defaultValue={defaultValue}
      min={0}
      max={maxValue}
      onChange={(value) => {
        value = value ? Math.trunc(value) : 0;
        onChange(value);
      }}
    />
  );
}
